/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Oct 2021
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import styles from './Body.module.css';
import backImg from '../../../../assets/images/Fireboard/back2_red.png';
import constants from '../../../../globalization';
import Table from '../Table';
import Sensor from '../Sensor';

const Body = props => {
  const {
    goBack,
    stationsWithSensors,
    stationsWithoutSensors,
    sensorsMap,
    onClickAddSensor,
    onClickDeleteSensor,
    sortFunction,
  } = props;

  const Sensors = ({ sensors }) => {
    return (
      <div className={styles.sensorView}>
        {sensors.map(sensor => <Sensor key={`sensorId-${sensor.id}`} sensor={sensor} onClickDeleteSensor={onClickDeleteSensor} />)}
      </div>
    );
  };

  const renderStations = stations => {
    return (
      stations.sort(sortFunction).map(station => {
        const sensors = sensorsMap.has(station.id) ? sensorsMap.get(station.id) : [];
        return (
          <div key={`stationId-${station.id}`} className={styles.tableWrapper}>
            <div className={styles.tableView}>
              <Table station={station} onClickAddSensor={onClickAddSensor} />
            </div>
            {Array.isArray(sensors) && sensors.length > 0
              ? <Sensors sensors={sensors} />
              : null
            }
          </div>
        )
      })
    );
  };

  return (
    <div className={styles.container}>
      <Header goBack={goBack} />
      <div className={styles.contentWrapper}>
        {renderStations(stationsWithSensors)}
        {renderStations(stationsWithoutSensors)}
      </div>
    </div>
  );
};

const Header = ({ goBack }) => {
  return (
    <div className={styles.headerWrapper}>
      <img src={backImg} className={styles.backArrow} onClick={goBack} alt='back' />
      <span className={styles.heading}>{constants.tableSensors}</span>
    </div>
  );
};

Header.propTypes = {
  goBack: PropTypes.func,
};

Header.defaultProps = {
  goBack: () => { },
};

export default Body;
